import { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import Select from "react-select";
import IRMenu from "./IRMenu";
import AuthorizedCapitalModal from "./AuthorizedCapitalModal";
import IssuedCapitalPage from "./IssuedCapitalModal";
import DeletePopup from "../../../myfin_v2/elements/DeletePopup";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../myfin_v2/elements/ErrorPopup";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close_grey.svg";
import { ReactComponent as LeftArrowIcon } from "../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../../../myfin_v2/assets/icons/dot.svg";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DownGreyIcon } from "../../../myfin_v2/assets/icons/down_grey.svg";
import { ReactComponent as DownArrow } from "../../../myfin_v2/assets/icons/down-arrow.svg";
import CustomDropdownIndicator from "../../../myfin_v2/elements/CustomDropdownIndicator";
import {
    getShareCapital, getLinkedCompanies, deleteAuthorizedCapital, deleteIssuedCapital, getInvestmentRegisterForms, updateAuthorizedCapital, updateIssuedCapital
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";

const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#ffffff',
        borderColor: '#c2e6d1',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderRadius: '6px',
        '&:hover': {
            borderColor: '#c2e6d1',
        },
        minHeight: '35px',
        height: '35px',
        borderWidth: '1px',
        cursor: 'pointer',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
        height: '33px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#205a46',
        margin: 0,
        padding: 0,
        border: 'none !important',
        outline: 'none !important',
        boxShadow: 'none !important',
        background: 'transparent !important',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
        margin: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#205a46',
        fontSize: '14px',
        margin: 0,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        padding: '4px',
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        marginTop: '6px',
        zIndex: 9999,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: (state.isSelected || state.isFocused) ? '#f4faf5' : 'transparent',
        color: '#205a46',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '13px',
        borderRadius: '4px',
        marginBottom: '2px',
        fontWeight: (state.isSelected || state.isFocused) ? 600 : 400,
        ':active': {
            backgroundColor: '#e8f6ed',
            color: '#205a46',
        },
        ':hover': {
            backgroundColor: '#f4faf5',
            color: '#205a46',
        },
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const ShareCapital = () => {

    const { irId } = useParams();
    const history = useHistory();

    const classOfShareOptions = ["Equity", "Preference", "Lease Leability"];
    const relationshipOptions = ["Director", "Investor", "Promoter", "Employee", "Affiliate"];

    const [anchorEl, setAnchorEl]                                             = useState(null);
    const [openAuthorizedCapitalPopoverId, setOpenAuthorizedCapitalPopoverId] = useState(null);
    const [selectedAuthorizedCapital, setSelectedAuthorizedCapital]           = useState(null);
    const [authorizedModalOpen, setAuthorizedModalOpen]                       = useState(false);
    const [authorizedModalType, setAuthorizedModalType]                       = useState(null);
    const [issuedCapitalAnchorEl, setIssuedCapitalAnchorEl]                   = useState(null);
    const [openIssuedCapitalPopoverId, setOpenIssuedCapitalPopoverId]         = useState(null);
    const [selectedIssuedCapital, setSelectedIssuedCapital]                   = useState(null);

    // ← NEW: full-screen page state instead of modal
    const [showIssuedCapitalPage, setShowIssuedCapitalPage]                   = useState(false);
    const [issuedCapitalPageType, setIssuedCapitalPageType]                   = useState(null);

    const [isEditing, setIsEditing]                                           = useState(false);
    const [isIssuedEditing, setIsIssuedEditing]                               = useState(false);
    const [authorizedCapital, setAuthorizedCapital]                           = useState([]);
    const [issuedCapital, setIssuedCapital]                                   = useState([]);
    const [editableRows, setEditableRows]                                     = useState([]);
    const [editableIssuedRows, setEditableIssuedRows]                         = useState([]);
    const [openDropdown, setOpenDropdown]                                     = useState(false);
    const [companySearch, setCompanySearch]                                   = useState("");
    const [highlightedIndex, setHighlightedIndex]                             = useState(0);
    const dropdownRef                                                         = useRef(null);
    const [selectedCompany, setSelectedCompany]                               = useState(null);
    const [showHeaderSearch, setShowHeaderSearch]                             = useState(false);
    const [headerSearchValue, setHeaderSearchValue]                           = useState("");
    const [companyList, setCompanyList]                                       = useState([]);
    const [linkedCompanies, setLinkedCompanies]                               = useState([]);
    const [deletePopup, setDeletePopup]                                       = useState({ isOpen: false, id: null, type: null });
    const [successPopup, setSuccessPopup]                                     = useState({ isOpen: false, message: "" });
    const [errorPopup, setErrorPopup]                                         = useState({ isOpen: false, message: "" });
    const [registerName, setRegisterName]                                     = useState("");

    useEffect(() => {
        if (!irId) return;
        getLinkedCompanies(irId)
            .then((res) => {
                const companies = res.data?.companies || [];
                setCompanyList(companies);
                setLinkedCompanies(companies);
            })
            .catch((err) => console.error("Failed to fetch linked companies:", err));

        getInvestmentRegisterForms(irId)
            .then(res => setRegisterName(res.data?.investmentRegister?.name || "Investment Register"))
            .catch(err => console.error(err));
    }, [irId]);

    const fetchShareCapitalData = async (searchQuery = headerSearchValue) => {
        try {
            if (!selectedCompany?._id) return;
            const res = await getShareCapital(irId, selectedCompany._id, searchQuery);
            if (res.data.success) {
                const authCap   = res.data.sharedCapital.authorizedCapital || [];
                const issuedCap = res.data.sharedCapital.issuedCapital     || [];
                setAuthorizedCapital(authCap);
                setIssuedCapital(issuedCap);
                setEditableRows(authCap);
                setEditableIssuedRows(issuedCap);
            }
        } catch (error) {
            console.log("Error fetching Share Capital:", error);
        }
    };

    useEffect(() => {
        if (companyList.length > 0 && !selectedCompany) {
            setSelectedCompany(companyList[0]);
        }
    }, [companyList]);

    useEffect(() => {
        if (selectedCompany) fetchShareCapitalData(headerSearchValue);
    }, [selectedCompany?._id]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpenDropdown(false);
                setCompanySearch("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filteredCompanyList = companyList.filter(c =>
        c.company_name.toLowerCase().includes((openDropdown ? companySearch : "").toLowerCase())
    );

    const handleDropdownKeyDown = (e) => {
        if (!openDropdown) {
            if (e.key === "ArrowDown" || e.key === "Enter") {
                setOpenDropdown(true);
                setHighlightedIndex(0);
                e.preventDefault();
            }
            return;
        }

        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((prev) =>
                prev < filteredCompanyList.length - 1 ? prev + 1 : 0
            );
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((prev) =>
                prev > 0 ? prev - 1 : filteredCompanyList.length - 1
            );
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (filteredCompanyList.length > 0 && filteredCompanyList[highlightedIndex]) {
                const comp = filteredCompanyList[highlightedIndex];
                setSelectedCompany(comp);
                setCompanySearch("");
                setOpenDropdown(false);
            }
        } else if (e.key === "Escape") {
            setOpenDropdown(false);
            setCompanySearch("");
        }
    };

    // ── Authorized Capital handlers ───────────────────────────────────────────
    const handleMenuClick  = (event, id) => { setAnchorEl(event.currentTarget); setOpenAuthorizedCapitalPopoverId(id); };
    const handleClose      = ()          => { setAnchorEl(null); setOpenAuthorizedCapitalPopoverId(null); };
    const handleEdit       = (item)      => { setSelectedAuthorizedCapital(item); setAuthorizedModalType("edit"); setAuthorizedModalOpen(true); handleClose(); };
    const handleModalClose = ()          => { setAuthorizedModalOpen(false); setSelectedAuthorizedCapital(null); setAuthorizedModalType(null); };
    const handleAdd        = ()          => { setSelectedAuthorizedCapital(null); setAuthorizedModalType("add"); setAuthorizedModalOpen(true); };

    const handleDeleteClick = (id, type) => {
        setDeletePopup({ isOpen: true, id, type });
        if (type === "authorized") handleClose();
        if (type === "issued") handleIssuedCapitalPopoverClose();
    };

    const handleConfirmDelete = async () => {
        const { id, type } = deletePopup;
        setDeletePopup({ isOpen: false, id: null, type: null });

        try {
            if (type === "authorized") {
                const res = await deleteAuthorizedCapital(irId, id);
                if (res.status === 200) {
                    setSuccessPopup({ isOpen: true, message: "Authorized capital removed." });
                    fetchShareCapitalData();
                }
            } else if (type === "issued") {
                const res = await deleteIssuedCapital(irId, id);
                if (res.status === 200) {
                    setSuccessPopup({ isOpen: true, message: "Issued capital removed." });
                    fetchShareCapitalData();
                }
            }
        } catch (err) {
            console.error(err);
            swal("Error", "Delete failed", "error");
        }
    };

    const handleAuthorizedSave = async () => {
        try {
            const promises = editableRows.map((row) => {
                const original = authorizedCapital.find(r => r._id === row._id);
                if (
                    original &&
                    (original.classOfShare !== row.classOfShare ||
                     original.noOfShares !== row.noOfShares ||
                     original.faceValue !== row.faceValue ||
                     original.amount !== row.amount)
                ) {
                    const payload = { ...row };
                    // delete payload._id;
                    delete payload._id;
                    delete payload.createdAt;
                    delete payload.updatedAt;
                    return updateAuthorizedCapital(irId, row._id, payload);
                }
                return null;
            }).filter(Boolean);

            if (promises.length > 0) {
                await Promise.all(promises);
                setSuccessPopup({ isOpen: true, message: "Authorized capital updated successfully" });
                fetchShareCapitalData();
            } else {
                setSuccessPopup({ isOpen: true, message: "No changes detected" });
            }
            setIsEditing(false);
        } catch (error) {
            console.error("Failed to update authorized capital:", error);
            swal("Error", error?.response?.data?.error || error?.response?.data?.message || "Failed to update authorized capital", "error");
        }
    };

    const handleIssuedSave = async () => {
        try {
            const promises = editableIssuedRows.map((row) => {
                const original = issuedCapital.find(r => r._id === row._id);
                if (
                    original &&
                    (original.shareHolderName !== row.shareHolderName ||
                     original.relationship !== row.relationship ||
                     original.classOfShare !== row.classOfShare ||
                     original.noOfShares !== row.noOfShares ||
                     original.faceValue !== row.faceValue ||
                     original.amount !== row.amount ||
                     original.holdingPercentage !== row.holdingPercentage)
                ) {
                    const payload = { ...row };
                    // delete payload._id;
                    delete payload._id;
                    delete payload.createdAt;
                    delete payload.updatedAt;
                    delete payload.shareHolderCompanyData;
                    delete payload.shareHolderCompanyID;
                    return updateIssuedCapital(irId, row._id, payload);
                }
                return null;
            }).filter(Boolean);

            if (promises.length > 0) {
                await Promise.all(promises);
                setSuccessPopup({ isOpen: true, message: "Issued capital updated successfully" });
                fetchShareCapitalData();
            } else {
                setSuccessPopup({ isOpen: true, message: "No changes detected" });
            }
            setIsIssuedEditing(false);
        } catch (error) {
            console.error("Failed to update issued capital:", error);
            swal("Error", error?.response?.data?.error || error?.response?.data?.message || "Failed to update issued capital", "error");
        }
    };

    const handleAuthorizedChange = (id, field, value) =>
        setEditableRows((prev) => prev.map((row) => row._id === id ? { ...row, [field]: value } : row));

    // ── Issued Capital handlers ───────────────────────────────────────────────
    const handleIssuedCapitalPopoverClick = (event, id) => { setIssuedCapitalAnchorEl(event.currentTarget); setOpenIssuedCapitalPopoverId(id); };
    const handleIssuedCapitalPopoverClose = ()          => { setIssuedCapitalAnchorEl(null); setOpenIssuedCapitalPopoverId(null); };

    // ← CHANGED: open full-screen page instead of modal
    const handleIssuedCapitalEdit = (item) => {
        setSelectedIssuedCapital(item);
        setIssuedCapitalPageType("edit");
        setShowIssuedCapitalPage(true);
        handleIssuedCapitalPopoverClose();
    };

    const handleAddIssuedCapital = () => {
        setSelectedIssuedCapital(null);
        setIssuedCapitalPageType("add");
        setShowIssuedCapitalPage(true);
    };

    const handleIssuedCapitalPageClose = () => {
        setShowIssuedCapitalPage(false);
        setSelectedIssuedCapital(null);
        setIssuedCapitalPageType(null);
    };

    const handleIssuedChange = (id, field, value) =>
        setEditableIssuedRows((prev) => prev.map((row) => row._id === id ? { ...row, [field]: value } : row));

    const handleSearchSubmit = (searchVal = headerSearchValue) => {
        fetchShareCapitalData(searchVal);
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearchSubmit(headerSearchValue);
        }
    };

    const handleSearchClose = () => {
        setShowHeaderSearch(false);
        setHeaderSearchValue("");
        fetchShareCapitalData("");
    };

    const open = Boolean(anchorEl);

    // Removed early return for IssuedCapitalPage to render it as a modal overlay instead

    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu activeTab={"Share Capital"} registerID={irId} />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout} style={{ paddingTop: "15px" }}
                >
                    <div className={investmentRegisterCss.iRContainer}>
                        <div className={investmentRegisterCss.topBar} style= {{ paddingBottom: "5px" }}>

                            {/* ── Linked Companies Dropdown ── */}
                            <div className={investmentRegisterCss.dropdownWrapper} ref={dropdownRef}>
                                <div
                                    className={investmentRegisterCss.dropdownField}
                                    onClick={() => setOpenDropdown(true)}
                                >
                                    <input
                                        type="text"
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            outline: "none",
                                            color: "#205a46",
                                            fontSize: "14px",
                                            width: "100%",
                                            padding: 0,
                                            cursor: "pointer",
                                        }}
                                        placeholder="Select Company"
                                        value={openDropdown ? companySearch : (selectedCompany ? selectedCompany.company_name : "Select Company")}
                                        onFocus={() => {
                                            setCompanySearch("");
                                            setHighlightedIndex(0);
                                            setOpenDropdown(true);
                                        }}
                                        onChange={(e) => {
                                            setCompanySearch(e.target.value);
                                            setHighlightedIndex(0);
                                            setOpenDropdown(true);
                                        }}
                                        onKeyDown={handleDropdownKeyDown}
                                    />
                                    <motion.span
                                        animate={{ rotate: openDropdown ? 180 : 0 }}
                                        transition={{ duration: 0.2 }}
                                        className={investmentRegisterCss.chevron}
                                        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenDropdown(prev => !prev);
                                        }}
                                    >
                                        <DownArrow />
                                    </motion.span>
                                </div>
                                {openDropdown && (
                                    <div className={investmentRegisterCss.dropdownMenuScrollable}>
                                        {filteredCompanyList.length > 0 ? (
                                            filteredCompanyList.map((company, i) => (
                                                <div
                                                    key={company._id}
                                                    className={`${investmentRegisterCss.dropdownItem} ${selectedCompany?._id === company._id || highlightedIndex === i ? investmentRegisterCss.dropdownItemActive : ""}`}
                                                    style={highlightedIndex === i ? { backgroundColor: "#f4faf5", color: "#205a46" } : {}}
                                                    onMouseEnter={() => setHighlightedIndex(i)}
                                                    onClick={() => {
                                                        setSelectedCompany(company);
                                                        setCompanySearch("");
                                                        setOpenDropdown(false);
                                                    }}
                                                >
                                                    {company.company_name}
                                                </div>
                                            ))
                                        ) : (
                                            <div className={investmentRegisterCss.dropdownItem} style={{ color: "#b3c0bd", cursor: "default" }}>
                                                No companies found
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* ── Header Actions ── */}
                            <div className={investmentRegisterCss.iRHeader}>
                                {showHeaderSearch ? (
                                    <div className={investmentRegisterCss.headerSearchBar}>
                                        <SearchIcon 
                                            className={investmentRegisterCss.headerSearchBarIcon} 
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleSearchSubmit(headerSearchValue)}
                                        />
                                        <input 
                                            autoFocus 
                                            type="text" 
                                            className={investmentRegisterCss.headerSearchInput} 
                                            placeholder="Type something..." 
                                            value={headerSearchValue} 
                                            onChange={(e) => setHeaderSearchValue(e.target.value)}
                                            onKeyDown={handleSearchKeyDown}
                                        />
                                        <CloseIcon 
                                            className={investmentRegisterCss.headerSearchClose} 
                                            onClick={handleSearchClose} 
                                        />
                                    </div>
                                ) : (
                                    <SearchIcon style={{ cursor: "pointer" }} onClick={() => setShowHeaderSearch(true)} />
                                )}
                            </div>
                        </div>

                        {/* ── Tables Container with #ffffff background and border radius ── */}
                        <div
                            className={investmentRegisterCss.shareCapitalLayout}
                            style={{
                                flexDirection: "column",
                                height: "auto",
                                minHeight: "calc(103vh - 120px)",
                                border: "1px solid #EAEEED",
                                background: "#ffffff",
                                borderRadius: "16px",
                                padding: "20px",
                                overflowY: "auto",
                                marginBottom: "20px",
                            }}
                        >
                            <div className={investmentRegisterCss.tableLayout} style={{ width: "100%" }}>

                                {/* ── Authorized Capital Table ── */}
                                <div className={investmentRegisterCss.tableConatiner}>
                                <div className={investmentRegisterCss.tableTitle}>
                                    <span>Authorized Capital</span>
                                    {!isEditing ? (
                                        <span className="d-flex gap-1">
                                            <Button btnColor={buttoncss.greyBg} icon={<EditIcon />} class_={investmentRegisterCss.editBtn} onClick={() => setIsEditing(true)} />
                                            <Button btnColor={buttoncss.greyBg} icon={<PlusPrimaryIcon />} class_={investmentRegisterCss.addBtnRow} onClick={handleAdd} />
                                        </span>
                                    ) : (
                                        <div className={investmentRegisterCss.saveCancelWrap}>
                                            <button className={investmentRegisterCss.cancelBtn} onClick={() => { setIsEditing(false); setEditableRows([...authorizedCapital]); }}>Cancel</button>
                                            <button className={investmentRegisterCss.saveBtn} onClick={handleAuthorizedSave}>Save</button>
                                        </div>
                                    )}
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", paddingLeft: "20px" }}>Class of share</th>
                                            <th style={{ textAlign: "right" }}>Number of shares</th>
                                            <th style={{ textAlign: "right" }}>Face value</th>
                                            <th style={{ textAlign: "right" }}>Amount</th>
                                            <th style={{ textAlign: "right", paddingRight: "20px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {editableRows.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "#b3c0bd" }}>No authorized capital data</td>
                                            </tr>
                                        ) : (
                                            editableRows.map((item) => (
                                                <tr key={item._id}>
                                                    <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                                                        {isEditing ? (
                                                            <div style={{ width: "220px", minWidth: "150px" }}>
                                                                <Select 
                                                                    options={classOfShareOptions.map(opt => ({ label: opt, value: opt }))}
                                                                    value={item.classOfShare ? { label: item.classOfShare, value: item.classOfShare } : null}
                                                                    onChange={(selected) => handleAuthorizedChange(item._id, "classOfShare", selected.value)}
                                                                    styles={customSelectStyles}
                                                                    placeholder="Select class of share"
                                                                    isSearchable={true}
                                                                    menuPortalTarget={document.body}
                                                                    components={{
                                                                        IndicatorSeparator: () => null,
                                                                        DropdownIndicator: CustomDropdownIndicator,
                                                                    }}
                                                                />
                                                            </div>
                                                        ) : (item.classOfShare)}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isEditing ? (<input type="number" value={item.noOfShares} className={investmentRegisterCss.inputShare} onChange={(e) => handleAuthorizedChange(item._id, "noOfShares", e.target.value)} placeholder="Enter Number..." />) : (item.noOfShares?.toLocaleString())}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.faceValue} onChange={(e) => handleAuthorizedChange(item._id, "faceValue", e.target.value)} placeholder="Enter Value..." />) : (item.faceValue)}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.amount} onChange={(e) => handleAuthorizedChange(item._id, "amount", e.target.value)} placeholder="Enter Amount..." />) : (item.amount?.toLocaleString())}
                                                    </td>
                                                    <td style={{ textAlign: "right", paddingRight: "20px" }}>
                                                        <MenuDotsIcon style={{ cursor: "pointer" }} onClick={(e) => handleMenuClick(e, item._id)} />
                                                        <Popover 
                                                            open={Boolean(anchorEl) && openAuthorizedCapitalPopoverId === item._id}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                            elevation={0}
                                                            PaperProps={{
                                                                style: {
                                                                    boxShadow: 'none',
                                                                    backgroundColor: 'transparent',
                                                                    overflow: 'visible'
                                                                }
                                                            }}
                                                        >
                                                            <div className={investmentRegisterCss.irOptions} style={{ width: "160px" }}>
                                                                <span style={{ borderBottom: "1px solid #EAEEED" }} onClick={() => handleEdit(item)}>Edit</span>
                                                                <span onClick={() => handleDeleteClick(item._id, "authorized")}>Delete</span>
                                                            </div>
                                                        </Popover>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* ── Issued Capital Table ── */}
                            <div className={investmentRegisterCss.tableConatiner}>
                                <div className={investmentRegisterCss.tableTitle}>
                                    <span>Issued Capital</span>
                                    {!isIssuedEditing ? (
                                        <span className="d-flex gap-1">
                                            <Button btnColor={buttoncss.greyBg} icon={<EditIcon />} class_={investmentRegisterCss.editBtn} onClick={() => setIsIssuedEditing(true)} />
                                            <Button btnColor={buttoncss.greyBg} icon={<PlusPrimaryIcon />} class_={investmentRegisterCss.addBtnRow} onClick={handleAddIssuedCapital} />
                                        </span>
                                    ) : (
                                        <div className={investmentRegisterCss.saveCancelWrap}>
                                            <button className={investmentRegisterCss.cancelBtn} onClick={() => { setIsIssuedEditing(false); setEditableIssuedRows([...issuedCapital]); }}>Cancel</button>
                                            <button className={investmentRegisterCss.saveBtn} onClick={handleIssuedSave}>Save</button>
                                        </div>
                                    )}
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", paddingLeft: "20px" }}>Share holder</th>
                                            <th style={{ textAlign: "left" }}>Relationship</th>
                                            <th style={{ textAlign: "left" }}>Class of Share</th>
                                            <th style={{ textAlign: "right" }}>No of shares</th>
                                            <th style={{ textAlign: "right" }}>Face value</th>
                                            <th style={{ textAlign: "right" }}>Amount</th>
                                            <th style={{ textAlign: "right" }}>Holding %</th>
                                            <th style={{ textAlign: "right", paddingRight: "20px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {editableIssuedRows.length === 0 ? (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: "center", padding: "20px", color: "#b3c0bd" }}>No issued capital data</td>
                                            </tr>
                                        ) : (
                                            editableIssuedRows.map((item) => (
                                                <tr key={item._id}>
                                                    <td style={{ textAlign: "left", paddingLeft: "20px" }}>{item.shareHolderName}</td>
                                                    <td style={{ textAlign: "left" }}>
                                                        {isIssuedEditing ? (
                                                            <div style={{ width: "200px", minWidth: "120px" }}>
                                                                <Select 
                                                                    options={relationshipOptions.map(opt => ({ label: opt, value: opt }))}
                                                                    value={item.relationship ? { label: item.relationship, value: item.relationship } : null}
                                                                    onChange={(selected) => handleIssuedChange(item._id, "relationship", selected.value)}
                                                                    styles={customSelectStyles}
                                                                    placeholder="Select relationship"
                                                                    isSearchable={true}
                                                                    menuPortalTarget={document.body}
                                                                    components={{
                                                                        IndicatorSeparator: () => null,
                                                                        DropdownIndicator: CustomDropdownIndicator,
                                                                    }}
                                                                />
                                                            </div>
                                                        ) : (item.relationship)}
                                                    </td>
                                                    <td style={{ textAlign: "left" }}>
                                                        {isIssuedEditing ? (
                                                            <div style={{ width: "200px", minWidth: "120px" }}>
                                                                <Select 
                                                                    options={classOfShareOptions.map(opt => ({ label: opt, value: opt }))}
                                                                    value={item.classOfShare ? { label: item.classOfShare, value: item.classOfShare } : null}
                                                                    onChange={(selected) => handleIssuedChange(item._id, "classOfShare", selected.value)}
                                                                    styles={customSelectStyles}
                                                                    placeholder="Select class"
                                                                    isSearchable={true}
                                                                    menuPortalTarget={document.body}
                                                                    components={{
                                                                        IndicatorSeparator: () => null,
                                                                        DropdownIndicator: CustomDropdownIndicator,
                                                                    }}
                                                                />
                                                            </div>
                                                        ) : (item.classOfShare)}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isIssuedEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.noOfShares} placeholder="Enter Number..." onChange={(e) => handleIssuedChange(item._id, "noOfShares", e.target.value)} />) : (item.noOfShares?.toLocaleString())}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isIssuedEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.faceValue} placeholder="Enter Values..." onChange={(e) => handleIssuedChange(item._id, "faceValue", e.target.value)} />) : (item.faceValue)}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isIssuedEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.amount} placeholder="Enter Amount..." onChange={(e) => handleIssuedChange(item._id, "amount", e.target.value)} />) : (item.amount?.toLocaleString())}
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {isIssuedEditing ? (<input type="number" className={investmentRegisterCss.inputShare} value={item.holdingPercentage} placeholder="Enter Holding %..." onChange={(e) => handleIssuedChange(item._id, "holdingPercentage", e.target.value)} />) : (`${item.holdingPercentage}%`)}
                                                    </td>
                                                    <td style={{ textAlign: "right", paddingRight: "20px" }}>
                                                        <MenuDotsIcon style={{ cursor: "pointer" }} onClick={(e) => handleIssuedCapitalPopoverClick(e, item._id)} />
                                                        <Popover 
                                                            open={Boolean(issuedCapitalAnchorEl) && openIssuedCapitalPopoverId === item._id}
                                                            anchorEl={issuedCapitalAnchorEl}
                                                            onClose={handleIssuedCapitalPopoverClose}
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                            elevation={0}
                                                            PaperProps={{
                                                                style: {
                                                                    boxShadow: 'none',
                                                                    backgroundColor: 'transparent',
                                                                    overflow: 'visible'
                                                                }
                                                            }}
                                                        >
                                                            <div className={investmentRegisterCss.irOptions} style={{ width: "160px" }}>
                                                                <span style={{ borderBottom: "1px solid #EAEEED" }} onClick={() => handleIssuedCapitalEdit(item)}>Edit</span>
                                                                <span onClick={() => handleDeleteClick(item._id, "issued")}>Delete</span>
                                                            </div>
                                                        </Popover>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                    </div>
                </motion.div>
            </div>

            {/* Authorized Capital Modal stays as modal — no change */}
            {authorizedModalOpen && (
                <AuthorizedCapitalModal
                    companyId={selectedCompany._id}
                    handleClose={handleModalClose}
                    data={selectedAuthorizedCapital}
                    type={authorizedModalType}
                    classOfShareOptions={classOfShareOptions}
                    investmentID={irId}
                    refreshData={fetchShareCapitalData}
                    onSuccess={(msg) => setSuccessPopup({ isOpen: true, message: msg || "Record saved successfully" })}
                    onError={(msg) => setErrorPopup({ isOpen: true, message: msg || "Something went wrong" })}
                />
            )}
            
            {showIssuedCapitalPage && (
                <IssuedCapitalPage
                    onBack={handleIssuedCapitalPageClose}
                    data={selectedIssuedCapital}
                    type={issuedCapitalPageType}
                    classOfShareOptions={classOfShareOptions}
                    relationshipOptions={relationshipOptions}
                    investmentID={irId}
                    refreshData={fetchShareCapitalData}
                    linkedCompanies={linkedCompanies}
                    companyId={selectedCompany?._id}
                    companyName={selectedCompany?.company_name}
                    onSuccess={(msg) => setSuccessPopup({ isOpen: true, message: msg || "Record saved successfully" })}
                    onError={(msg) => setErrorPopup({ isOpen: true, message: msg || "Something went wrong" })}
                />
            )}

            <DeletePopup
                isOpen={deletePopup.isOpen}
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeletePopup({ isOpen: false, id: null, type: null })}
            />
            
            <SuccessPopup
                isOpen={successPopup.isOpen}
                message={successPopup.message}
                onClose={() => setSuccessPopup({ isOpen: false, message: "" })}
            />

            <ErrorPopup
                isOpen={errorPopup.isOpen}
                message={errorPopup.message}
                onClose={() => setErrorPopup({ isOpen: false, message: "" })}
            />
        </>
    );
};

export default ShareCapital;